import Typography from '@mui/material/Typography'
import smavaIllustration from 'assets/icons/voucher-money-smava-full.png'
import {
  Content,
  Illustration,
  Notice
} from './RCEVariantCEditPageNotice.styles'
export interface RCEVariantCEditPageNoticeProps {
  amount: number
}

const RCEVariantCEditPageNotice = ({
  amount
}: RCEVariantCEditPageNoticeProps) => (
  <Notice>
    <Content>
      <Illustration
        src={smavaIllustration}
        alt="Illustration für smava Gutschein"
        aria-hidden="true"
      />
      <Typography variant="body1" fontSize={16} fontWeight={700}>
        {amount} € Gutschein erhalten!
      </Typography>
      <Typography variant="body1" fontSize={16}>
        Jetzt bei smava.
      </Typography>
    </Content>
  </Notice>
)

export default RCEVariantCEditPageNotice
